import { useCallback } from 'react'
import SegmentedOption from 'LuxKit/SegmentedOptions/SegmentedOption'
import SegmentedOptionsGroup from 'LuxKit/SegmentedOptions/SegmentedOptionsGroup'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import type { OfferPageMultiRoomMode } from 'contexts/OfferPage/offerPageStateReducer'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import { useIntl } from 'react-intl'

interface Props {
  inputsName: string
  mode: OfferPageMultiRoomMode
  onModeChange?: (mode: OfferPageMultiRoomMode) => void
}

function MultiRoomModeToggle({ inputsName, mode, onModeChange }: Props) {
  const intl = useIntl()
  const dispatch = useOfferPageDispatch()

  const onControlModeChange = useCallback((mode: OfferPageMultiRoomMode) => {
    dispatch({ type: OfferPageActions.toggleMultiRoomMode, multiRoomMode: mode })
  }, [dispatch])

  return (
    <SegmentedOptionsGroup onValueChange={onModeChange ?? onControlModeChange} inputsName={inputsName}>
      <SegmentedOption
        title={intl.formatMessage({
          id: 'FxysofOuIycLSsxYWYcJ',
          defaultMessage: 'Individually',
          description: 'Option label for selecting rooms individually in multi-room booking',
        })}
        value="individual"
        checked={mode === 'individual'}
      />
      <SegmentedOption
        title={intl.formatMessage({
          id: 'llH5PsAKJuIK1E6kAAox',
          defaultMessage: 'Same for all rooms',
          description: 'Option label for applying same selection to all rooms in multi-room booking',
        })}
        value="same-room"
        checked={mode === 'same-room'}
      />
    </SegmentedOptionsGroup>
  )
}

export default withOfferPageState((state) => {
  return {
    mode: state.multiRoomMode,
  }
}, MultiRoomModeToggle)
